import { gray60 } from "../../../../common/helpers/colors";
import {
  pathogenicityYScale,
  pathogenicityLabelsLong,
  pathogenicityFilters,
  pathogenicityLabelsShort,
} from "../../constants/pathogenicity";

const pathogenicityTicks = pathogenicityFilters.map((x, i) => ({
  tick: pathogenicityLabelsShort[i],
  label: pathogenicityLabelsShort[i],
  helpText: pathogenicityLabelsLong[i],
  y: pathogenicityYScale[i],
  color: pathogenicityYScale[i] === 0.5 ? gray60 : undefined,
}));

export default pathogenicityTicks;
